import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19 20.75a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0-.75.75v16c0 .414.336.75.75.75zm-.75-16v14.5H5.75V4.75zm-4.642 7.689a.75.75 0 0 0-1.216-.878l-2 2.773A.75.75 0 0 0 11 15.523h1.52l-1.125 1.534a.75.75 0 1 0 1.21.887l2-2.728A.75.75 0 0 0 14 14.023h-1.534zM6.75 6a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-9A.75.75 0 0 1 6.75 9zm4.5 2.25h1.5v-1.5h-1.5zm-1.5-1.5v1.5h-1.5v-1.5zm4.5 0v1.5h1.5v-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }